import React from "react";
import {AlertConfiguration} from "../../util/Util";

const SblDeviceConfiguration = () => {
    return (
        <AlertConfiguration></AlertConfiguration>
    );
}

export default SblDeviceConfiguration



// WEBPACK FOOTER //
// ./src/components/devicemanagement/sbldevice/SblDeviceConfiguration.js